<template>
	<r-standard-modal-form
		class="timeline-record-modal-outter"
		:style="{
			height: `580px`,
			width: `620px`,
		}"
		@closeModal="$emit('closeModal')"
	>
		<span slot="title"> {{ recordTitle || 'Unnamed task' }} </span>
		<div slot="body" class="import-data-modal-body">
			<div 
				class="timeline-container"
				v-for="sheetView in timelineSheetViewsToShow"
				:key="sheetView.$internals.metaProperties.meta.guid"
			>
				<timeline-sheet-view-updater
					v-if="sheetView.type === 'timeline'"
					:record="record"
					:sheetView="sheetView"
				>
				</timeline-sheet-view-updater>
				<gantt-sheet-view-updater
					v-if="sheetView.type === 'gantt'"
					:record="record"
					:sheetView="sheetView"
				>
				</gantt-sheet-view-updater>
			</div>
		</div>
	</r-standard-modal-form>
</template>
<script>

import TimelineSheetViewUpdater from 'vue/sheet-views/timeline/timeline-sheet-view-updater';
import GanttSheetViewUpdater from 'vue/sheet-views/gantt/gantt-sheet-view-updater.vue';

export default {
	name:'timeline-record-modal',
	data(){
		return{
		};
	},
	components:{
		TimelineSheetViewUpdater,
		GanttSheetViewUpdater,
	},
	props:{
		record:{
			required: true,
			type: Object,
		},
		sheetView:{
			required: false,
		},
	},
	computed:{
		schema(){
			return this.dataStore.meta.schema;
		},
		dataStore(){
			return this.record.dataStore;
		},
		primaryLabelGUID(){
			return this.schema.getPrimaryNameFieldGUID();
		},
		recordTitle(){
			return this.record.getDisplayLabel(this.$root.systemState);
			// if(this.record.fieldValues[this.primaryLabelGUID]){					
			// 	return this.record.fieldValues[this.primaryLabelGUID].value;
			// }
		},
		timelineSheetViewsToShow(){
			if(this.sheetView){
				return [this.sheetView];
			}
			else{
				return this.dataStore.getAllSheetViews().filter(function onlyCanvasViews(sheetView){
					return sheetView.type === 'timeline' || sheetView.type === 'gantt';
				});
			}			
		},
	},
	methods:{
		
	},
}
</script>

<style scoped lang="scss">

.timeline-record-modal-outter{
	width: 100%;

	.import-data-modal-body{
		width: 100%;
	}
}

</style>
